exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.promotion-tabs[data-v-416f7728] {\n  padding: 12px;\n}\n", ""]);

// exports
